import { defineStore } from 'pinia'

export const useCompletedPaymentStore = defineStore({
    id: 'completed-payment',
    state: () => ({
        PaymentID: 0 as Number,
    }),
    actions: {
        setPaymentID(paymentID: Number, hasAttachments: Boolean, attachmentMessage: string) {
            this.PaymentID = paymentID;
        },
        clearPaymentID() {
            this.PaymentID = 0 as Number;
        },
    },
    persist: true,
})
